webpackJsonp([86],{

/***/ "+LB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1DHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_cell = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uwyH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_cell,
  src_components_cell,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2sLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_button = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_button,
  src_components_x_button,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = void 0;

//  加载配置
config = __webpack_require__("g+Cn").default;

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4K2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2c7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: picker_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_picker = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Q7uw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_picker,
  src_components_picker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/index.vue + 3 modules
var cell = __webpack_require__("1DHf");

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/index.vue + 3 modules
var popup = __webpack_require__("HD9R");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27223f69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",function(){return [_vm._v(_vm._s(_vm.leftText))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",function(){return [_vm._v(_vm._s(_vm.rightText))]})],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("XZOv")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: cell["a" /* default */],
    Popup: popup["a" /* default */],
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: cell["a" /* default */],
    Popup: popup["a" /* default */],
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413ccea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]},{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("5jbP")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/range.js
var range = __webpack_require__("ZX6s");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/number/range.js + 1 modules
var number_range = __webpack_require__("/lxc");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime-range/index.vue
//
//
//
//
//
//






/* harmony default export */ var datetime_range = ({
  name: 'datetime-range',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    startDate: String,
    endDate: String,
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    rawValue: Boolean,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String
  },
  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      cellFormat: function cellFormat(val) {
        return val[0] + ' ' + val[1] + ':' + val[2];
      }
    };
  },

  computed: {
    list: function list() {
      if (!this.startDate || !this.endDate) {
        return [];
      }
      var datesNames = Object(range["a" /* default */])(this.startDate, this.endDate, this.format);
      var datesValues = Object(range["a" /* default */])(this.startDate, this.endDate, 'YYYY-MM-DD');
      var hours = Object(number_range["a" /* default */])(0, 23);
      var minutes = Object(number_range["a" /* default */])(0, 59);
      return [datesNames.map(function (one, index) {
        return {
          name: one,
          value: datesValues[index]
        };
      }), hours, minutes];
    },
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime-range/index.vue
//
//
//
//
//
//






/* harmony default export */ var components_datetime_range = ({
  name: 'datetime-range',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    startDate: String,
    endDate: String,
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    rawValue: Boolean,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String
  },
  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      cellFormat: function cellFormat(val) {
        return val[0] + ' ' + val[1] + ':' + val[2];
      }
    };
  },

  computed: {
    list: function list() {
      if (!this.startDate || !this.endDate) {
        return [];
      }
      var datesNames = Object(range["a" /* default */])(this.startDate, this.endDate, this.format);
      var datesValues = Object(range["a" /* default */])(this.startDate, this.endDate, 'YYYY-MM-DD');
      var hours = Object(number_range["a" /* default */])(0, 23);
      var minutes = Object(number_range["a" /* default */])(0, 59);
      return [datesNames.map(function (one, index) {
        return {
          name: one,
          value: datesValues[index]
        };
      }), hours, minutes];
    },
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ac97e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime-range/index.vue
var datetime_range_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('popup-picker',{attrs:{"data":_vm.list,"title":_vm.title,"display-format":_vm.cellFormat,"inline-desc":_vm.inlineDesc,"placeholder":_vm.placeholder,"value-text-align":_vm.valueTextAlign,"column-width":[1/2, 1/6]},on:{"on-hide":_vm.emitHide,"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)}
var datetime_range_staticRenderFns = []
var datetime_range_esExports = { render: datetime_range_render, staticRenderFns: datetime_range_staticRenderFns }
/* harmony default export */ var src_components_datetime_range = (datetime_range_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime-range/index.vue
var datetime_range_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime_range___vue_template_functional__ = false
/* styles */
var datetime_range___vue_styles__ = null
/* scopeId */
var datetime_range___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime_range___vue_module_identifier__ = null
var datetime_range_Component = datetime_range_normalizeComponent(
  components_datetime_range,
  src_components_datetime_range,
  datetime_range___vue_template_functional__,
  datetime_range___vue_styles__,
  datetime_range___vue_scopeId__,
  datetime_range___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_datetime_range = __webpack_exports__["a"] = (datetime_range_Component.exports);


/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5dss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6d97f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("6f65")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6f65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BmTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__ = __webpack_require__("yD8N");


/* harmony default export */ __webpack_exports__["a"] = ({

  parklotList: function parklotList(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/parklot/list', data);
  },

  channelList: function channelList(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/wx/parklot/channel/list', data);
  },

  unlicensedCarInOut: function unlicensedCarInOut(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/parklot/inoutparklot/opengate', data);
  },

  queryParklot: function queryParklot(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/wx/parklot/parklot/queryparklot', data);
  },

  noPlatenumPay: function noPlatenumPay(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/order/orderpay/noplatenumpay', data);
  },

  getChanelInfo: function getChanelInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.get('/api/parklot/wx/parklot/inoutparklot/getChanelInfo?parklotId=' + data.parklotId + '&openId=' + data.openId + '&channelId=' + data.channelId + '&scanType=' + data.scanType);
  },

  noPlateOutQuerycharge: function noPlateOutQuerycharge(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/temporarycarcharge/querycharge', data);
  },

  listParklots: function listParklots(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/apiInvoice/parklot/parkingfeeserial/listParklots', data);
  }
});

/***/ }),

/***/ "Ckmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F7NO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.1ac1895.gif";

/***/ }),

/***/ "G6U3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GRGv":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./myFilter.js": "wwVC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GRGv";

/***/ }),

/***/ "GXM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__ = __webpack_require__("yD8N");


/* harmony default export */ __webpack_exports__["a"] = ({

  outinRecord: function outinRecord(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/outinRecord/list/' + id);
  },

  payRecord: function payRecord(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/payrecord/list', data);
  },

  monthRecord: function monthRecord(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/wx/parklot/vehicle/list', data);
  },

  vipRecord: function vipRecord(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/viprecord/list/' + data);
  },

  addCar: function addCar(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/vehicle/addBind', data);
  },

  carData: function carData(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/vehicle/wxBindAll/' + id);
  },

  deleteBind: function deleteBind(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/vehicle/deleteBind', data);
  },

  queryMainParklot: function queryMainParklot() {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.get('/api/parklot/wx/parklot/queryMainParklot');
  }
});

/***/ }),

/***/ "HD9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("gsj7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HiEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__ = __webpack_require__("yD8N");


/* harmony default export */ __webpack_exports__["a"] = ({

  payMoney: function payMoney(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.get('/wxpay/createOrder?openId=' + params.openId + '&plateNumber=' + params.plateNumber + '&money=' + params.money);
  },

  authorization: function authorization(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/pay/wx/user/getWxOpenIdInfo', data);
  },

  temppay: function temppay(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/order/orderpay/temppay', data);
  },

  temporarycarcharge: function temporarycarcharge(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/wx/temporarycarcharge/querycharge', data);
  },

  noPlatenumPay: function noPlatenumPay(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('/api/parklot/order/orderpay/noplatenumpay', data);
  },

  aliUserInfo: function aliUserInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.post('https://tcc.grg.cn/grgApi/user/userInfo/getAliUserInfo', data);
  },

  queryMainParklot: function queryMainParklot(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.get('/api/parklot/wx/parklot/queryMainParklot', data);
  }
});

/***/ }),

/***/ "IJjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingMore.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LoadingMore = ({
  props: {
    offset: {
      type: Number,
      default: 40
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    infiniteLoading: {
      type: Boolean,
      default: false
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: true
    },
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    }
    //    infiniteDone: {
    //      type: Function,
    //      default: undefined,
    //      require: false
    //    },
  },
  data: function data() {
    return {
      top: 0,
      state: 0,
      startY: 0,
      touching: false
      // infiniteLoading: false
    };
  },

  methods: {
    touchStart: function touchStart(e) {
      this.startY = e.targetTouches[0].pageY;
      this.startScroll = this.$el.scrollTop || 0;
      this.touching = true;
    },
    touchMove: function touchMove(e) {
      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return;
      }
      var diff = e.targetTouches[0].pageY - this.startY - this.startScroll;
      if (diff > 0) e.preventDefault();
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0);

      if (this.state === 2) {
        // in refreshing
        return;
      }
      if (this.top >= this.offset) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    touchEnd: function touchEnd(e) {
      if (!this.enableRefresh) return;
      this.touching = false;
      if (this.state === 2) {
        // in refreshing
        this.state = 2;
        this.top = this.offset;
        return;
      }
      if (this.top >= this.offset) {
        // do refresh
        this.refresh();
      } else {
        // cancel refresh
        this.state = 0;
        this.top = 0;
      }
    },
    refresh: function refresh() {
      this.state = 2;
      this.top = this.offset;
      //this.infiniteLoading=false
      this.$emit('update:infiniteLoading', false);
      this.onRefresh(this.refreshDone);
    },
    refreshDone: function refreshDone() {
      this.state = 0;
      this.top = 0;
    },
    infinite: function infinite() {
      this.$emit('update:infiniteLoading', true);
      //this.infiniteLoading = true
      this.onInfinite(this.infiniteDone);
    },
    infiniteDone: function infiniteDone() {
      this.$emit('update:infiniteLoading', false);
      //this.infiniteLoading = false
    },
    onScroll: function onScroll(e) {
      if (!this.enableInfinite || this.infiniteLoading) {
        return;
      }
      var outerHeight = this.$el.clientHeight;
      var innerHeight = this.$el.querySelector('.inner').clientHeight;
      var scrollTop = this.$el.scrollTop;
      var ptrHeight = this.onRefresh ? this.$el.querySelector('.pull-refresh').clientHeight : 0;
      var infiniteHeight = this.$el.querySelector('.load-more').clientHeight;
      var bottom = innerHeight - outerHeight - scrollTop - ptrHeight;
      if (bottom < infiniteHeight) this.infinite();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingMore.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LoadingMore = ({
  props: {
    offset: {
      type: Number,
      default: 40
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    infiniteLoading: {
      type: Boolean,
      default: false
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: true
    },
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    }
    //    infiniteDone: {
    //      type: Function,
    //      default: undefined,
    //      require: false
    //    },
  },
  data: function data() {
    return {
      top: 0,
      state: 0,
      startY: 0,
      touching: false
      // infiniteLoading: false
    };
  },

  methods: {
    touchStart: function touchStart(e) {
      this.startY = e.targetTouches[0].pageY;
      this.startScroll = this.$el.scrollTop || 0;
      this.touching = true;
    },
    touchMove: function touchMove(e) {
      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return;
      }
      var diff = e.targetTouches[0].pageY - this.startY - this.startScroll;
      if (diff > 0) e.preventDefault();
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0);

      if (this.state === 2) {
        // in refreshing
        return;
      }
      if (this.top >= this.offset) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    touchEnd: function touchEnd(e) {
      if (!this.enableRefresh) return;
      this.touching = false;
      if (this.state === 2) {
        // in refreshing
        this.state = 2;
        this.top = this.offset;
        return;
      }
      if (this.top >= this.offset) {
        // do refresh
        this.refresh();
      } else {
        // cancel refresh
        this.state = 0;
        this.top = 0;
      }
    },
    refresh: function refresh() {
      this.state = 2;
      this.top = this.offset;
      //this.infiniteLoading=false
      this.$emit('update:infiniteLoading', false);
      this.onRefresh(this.refreshDone);
    },
    refreshDone: function refreshDone() {
      this.state = 0;
      this.top = 0;
    },
    infinite: function infinite() {
      this.$emit('update:infiniteLoading', true);
      //this.infiniteLoading = true
      this.onInfinite(this.infiniteDone);
    },
    infiniteDone: function infiniteDone() {
      this.$emit('update:infiniteLoading', false);
      //this.infiniteLoading = false
    },
    onScroll: function onScroll(e) {
      if (!this.enableInfinite || this.infiniteLoading) {
        return;
      }
      var outerHeight = this.$el.clientHeight;
      var innerHeight = this.$el.querySelector('.inner').clientHeight;
      var scrollTop = this.$el.scrollTop;
      var ptrHeight = this.onRefresh ? this.$el.querySelector('.pull-refresh').clientHeight : 0;
      var infiniteHeight = this.$el.querySelector('.load-more').clientHeight;
      var bottom = innerHeight - outerHeight - scrollTop - ptrHeight;
      if (bottom < infiniteHeight) this.infinite();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c157bbac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingMore.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yo-scroll",class:{'down':(_vm.state===0),'up':(_vm.state==1),refresh:(_vm.state===2),touch:_vm.touching},on:{"touchstart":function($event){return _vm.touchStart($event)},"touchmove":function($event){return _vm.touchMove($event)},"touchend":function($event){return _vm.touchEnd($event)},"scroll":function($event){(_vm.onInfinite || _vm.infiniteLoading) ? _vm.onScroll($event) : undefined}}},[_c('section',{staticClass:"inner",style:({ transform: 'translate3d(0, ' + _vm.top + 'px, 0)' })},[_c('header',{staticClass:"pull-refresh"},[_vm._t("pull-refresh",function(){return [_c('span',{staticClass:"down-tip"},[_vm._v("下拉更新")]),_vm._v(" "),_c('span',{staticClass:"up-tip"},[_vm._v("松开更新")]),_vm._v(" "),_c('span',{staticClass:"refresh-tip"},[_vm._v("更新中")])]})],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('footer',{staticClass:"load-more"},[_vm._t("load-more",function(){return [_c('span',[_vm._v(_vm._s(_vm.isLoading==true?'加载更多...':'暂无更多数据'))])]})],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LoadingMore = (esExports);
// CONCATENATED MODULE: ./src/components/LoadingMore.vue
function injectStyle (ssrContext) {
  __webpack_require__("UELi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_LoadingMore,
  selectortype_template_index_0_src_components_LoadingMore,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LoadingMore = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var modules = {};
var modulesContext = __webpack_require__("YkTy");
modulesContext.keys().map(function (key) {
  // console.log(key)
  var fileName = key.split('/')[1];
  var module = modulesContext(key).default;
  // console.log(module)
  if (!module.namespace) throw new Error('请定义' + fileName + '的namespace属性');

  module.namespaced = true; // 必须要有，否则getter拿不到
  modules[module.namespace] = module;
});
// console.log(modules)
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modules)
}));

/***/ }),

/***/ "JeNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  namespace: 'faceCompare', // 注意定义namespace, 将会在store中存储
  state: {
    sourceList: []
  },
  getters: {
    sourceList: function sourceList(state) {
      return state.sourceList;
    }

  },
  actions: {},
  mutations: {
    mutationsSourceList: function mutationsSourceList(state, value) {
      state.sourceList = value;
    }
  }
});

/***/ }),

/***/ "JvV8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LgOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f818f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.icon,"alt":""}})]})],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ckmr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/api/pay.js
var pay = __webpack_require__("HiEW");

// EXTERNAL MODULE: ./src/api/personInfo.js
var personInfo = __webpack_require__("GXM7");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
	name: 'app',
	data: function data() {
		return {
			loading: true,
			oQuery: undefined
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.rem();
	},

	computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
		appType: function appType(state) {
			return state.payParams.appType;
		}
	})),
	watch: {
		'$route': function $route(to, from) {
			//	跳过下载页，因为下载页需要在浏览器中打开
			if (to.name === "download") {
				return;
			}

			if (to.query && to.query.companyId) {
				this.oQuery = to.query;
			}
			if (this.oQuery) {
				this.getCompanyId(from);
			} else if (!this.oQuery && !localStorage.getItem('parklotInfo')) {
				if (to.path.indexOf('/toggleParklot') < 0) {
					this.$router.push({ path: '/toggleParklot' });
				}
				// Api2.queryMainParklot().then( res => {
				// 	if ( res.result && res.result.length == 1 ) {
				// 		localStorage.setItem( 'parklotInfo', JSON.stringify( res.result[ 0 ] ) );
				// 		this.$store.commit( 'payParams/getParklotInfo', res.result[ 0 ] );
				// 		this.$vux.toast.show( { text: '选择停车场成功！' } );
				// 	} else {
				// 		if ( to.path.indexOf( '/toggleParklot' ) < 0 ) {
				// 			this.$router.push( { path: '/toggleParklot' } );
				// 		}
				// 	}
				// } );
			}
		}
	},
	methods: {
		rem: function rem() {
			(function (win, doc) {
				function change() {
					doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 375 * 100 + 'px';
				}
				change();
				win.addEventListener('resize', change, false);
				win.addEventListener('orientationchange', change, false);
			})(window, document);
		},
		getCompanyId: function getCompanyId(to) {
			var _this = this;

			this.$store.commit('payParams/getParklotInfoIsSend', true);
			this.$vux.loading.show();
			pay["a" /* default */].queryMainParklot().then(function (res) {
				_this.$store.commit('payParams/getParklotInfoIsSend', false);
				_this.$vux.loading.hide();
				var getNum = 0;
				res.result.forEach(function (item) {
					if (item.companyId === _this.oQuery.companyId) {
						localStorage.setItem('parklotInfo', stringify_default()(item));
						_this.$store.commit('payParams/getParklotInfo', item);
						getNum++;
					}
				});
				if (getNum === 0) {
					_this.$vux.toast.show({ text: '信息匹配失败，请手动选择停车场!', type: 'text' });
					_this.$router.push({ path: '/toggleParklot' });
				}
			}).catch(function (err) {
				console.error(err);
				_this.$vux.loading.hide();
				_this.$vux.toast.show({ text: '信息查询失败，请手动选择停车场!', type: 'text' });
				_this.$router.push({ path: '/toggleParklot' });
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


//
//
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_App = ({
	name: 'app',
	data: function data() {
		return {
			loading: true,
			oQuery: undefined
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.rem();
	},

	computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
		appType: function appType(state) {
			return state.payParams.appType;
		}
	})),
	watch: {
		'$route': function $route(to, from) {
			//	跳过下载页，因为下载页需要在浏览器中打开
			if (to.name === "download") {
				return;
			}

			if (to.query && to.query.companyId) {
				this.oQuery = to.query;
			}
			if (this.oQuery) {
				this.getCompanyId(from);
			} else if (!this.oQuery && !localStorage.getItem('parklotInfo')) {
				if (to.path.indexOf('/toggleParklot') < 0) {
					this.$router.push({ path: '/toggleParklot' });
				}
				// Api2.queryMainParklot().then( res => {
				// 	if ( res.result && res.result.length == 1 ) {
				// 		localStorage.setItem( 'parklotInfo', JSON.stringify( res.result[ 0 ] ) );
				// 		this.$store.commit( 'payParams/getParklotInfo', res.result[ 0 ] );
				// 		this.$vux.toast.show( { text: '选择停车场成功！' } );
				// 	} else {
				// 		if ( to.path.indexOf( '/toggleParklot' ) < 0 ) {
				// 			this.$router.push( { path: '/toggleParklot' } );
				// 		}
				// 	}
				// } );
			}
		}
	},
	methods: {
		rem: function rem() {
			(function (win, doc) {
				function change() {
					doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 375 * 100 + 'px';
				}
				change();
				win.addEventListener('resize', change, false);
				win.addEventListener('orientationchange', change, false);
			})(window, document);
		},
		getCompanyId: function getCompanyId(to) {
			var _this = this;

			this.$store.commit('payParams/getParklotInfoIsSend', true);
			this.$vux.loading.show();
			pay["a" /* default */].queryMainParklot().then(function (res) {
				_this.$store.commit('payParams/getParklotInfoIsSend', false);
				_this.$vux.loading.hide();
				var getNum = 0;
				res.result.forEach(function (item) {
					if (item.companyId === _this.oQuery.companyId) {
						localStorage.setItem('parklotInfo', stringify_default()(item));
						_this.$store.commit('payParams/getParklotInfo', item);
						getNum++;
					}
				});
				if (getNum === 0) {
					_this.$vux.toast.show({ text: '信息匹配失败，请手动选择停车场!', type: 'text' });
					_this.$router.push({ path: '/toggleParklot' });
				}
			}).catch(function (err) {
				console.error(err);
				_this.$vux.loading.hide();
				_this.$vux.toast.show({ text: '信息查询失败，请手动选择停车场!', type: 'text' });
				_this.$router.push({ path: '/toggleParklot' });
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e9fc32c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.name,staticClass:"viewContainer"}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.name,staticClass:"viewContainer"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("5dss")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LoadingMore__ = __webpack_require__("IJjW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ToggleBtn__ = __webpack_require__("pLXd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_pay__ = __webpack_require__("HiEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tools_tool__ = __webpack_require__("kcuN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vconsole__ = __webpack_require__("Lw6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vconsole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vconsole__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_group_index_vue__ = __webpack_require__("rHil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vux_src_components_cell_index_vue__ = __webpack_require__("1DHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vux_src_components_grid_grid_vue__ = __webpack_require__("kNDc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vux_src_components_grid_grid_item_vue__ = __webpack_require__("LgOF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vux_src_plugins_confirm_index_js__ = __webpack_require__("NXWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vux_src_components_x_button_index_vue__ = __webpack_require__("2sLL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vux_src_plugins_loading_index_js__ = __webpack_require__("Y+qm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_plugins_toast_index_js__ = __webpack_require__("3BeM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_plugins_ajax_index_js__ = __webpack_require__("yD8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vux_src_plugins_wechat_index_js__ = __webpack_require__("n6Wb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vux_src_components_alert_index_vue__ = __webpack_require__("mzja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vux_src_components_x_input_index_vue__ = __webpack_require__("pDNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vux_src_components_selector_index_vue__ = __webpack_require__("wwIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vux_src_components_confirm_index_vue__ = __webpack_require__("62KO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vux_src_components_icon_index_vue__ = __webpack_require__("oWtu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vux_src_components_toast_index_vue__ = __webpack_require__("rLAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vux_src_components_x_dialog_index_vue__ = __webpack_require__("/kga");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vux_src_components_popup_index_vue__ = __webpack_require__("HD9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vux_src_components_datetime_range_index_vue__ = __webpack_require__("4K2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__tools_preset_js__ = __webpack_require__("dU/V");












__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__tools_tool__["a" /* default */]);


if (false) {
  new VConsole();
}






















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$preset = __WEBPACK_IMPORTED_MODULE_32__tools_preset_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('alert', __WEBPACK_IMPORTED_MODULE_23_vux_src_components_alert_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('Dialog', __WEBPACK_IMPORTED_MODULE_29_vux_src_components_x_dialog_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('toast', __WEBPACK_IMPORTED_MODULE_28_vux_src_components_toast_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_27_vux_src_components_icon_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('group', __WEBPACK_IMPORTED_MODULE_13_vux_src_components_group_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('cell', __WEBPACK_IMPORTED_MODULE_14_vux_src_components_cell_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('grid', __WEBPACK_IMPORTED_MODULE_15_vux_src_components_grid_grid_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('gridItem', __WEBPACK_IMPORTED_MODULE_16_vux_src_components_grid_grid_item_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('x-input', __WEBPACK_IMPORTED_MODULE_24_vux_src_components_x_input_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('x-button', __WEBPACK_IMPORTED_MODULE_18_vux_src_components_x_button_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('selector', __WEBPACK_IMPORTED_MODULE_25_vux_src_components_selector_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('confirm', __WEBPACK_IMPORTED_MODULE_26_vux_src_components_confirm_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('popup', __WEBPACK_IMPORTED_MODULE_30_vux_src_components_popup_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('datetime-range', __WEBPACK_IMPORTED_MODULE_31_vux_src_components_datetime_range_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vux_src_plugins_loading_index_js__["a" /* default */], { position: 'middle' });
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17_vux_src_plugins_confirm_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_20_vux_src_plugins_toast_index_js__["a" /* default */], { position: 'middle', type: 'text', time: 1500, 'is-show-mask': true });
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_21_vux_src_plugins_ajax_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_22_vux_src_plugins_wechat_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__filters__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('v-scroll', __WEBPACK_IMPORTED_MODULE_7__components_LoadingMore__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('ToggleBtn', __WEBPACK_IMPORTED_MODULE_8__components_ToggleBtn__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  if (from.name) {
    var contentElem = document.querySelector('.scrollYContainer');
    var scrollTop = contentElem ? contentElem.scrollTop : '0';
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.common.scrollPos[from.name] = scrollTop;
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].$vux.loading.hide();
});

var setConfig = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/json';
  config.headers['appId'] = setConfig.appid;

  if (false) {
    config.url = config.url.replace("/api/", "/api2/");
  }

  if (localStorage.getItem('parklotInfo')) {
    var parklotInfo = JSON.parse(localStorage.getItem('parklotInfo'));
    config.headers['companyId'] = parklotInfo.companyId;
  } else {
    var parklotHref = window.location.href;
    if (parklotHref.indexOf('unlicensedQroNew') !== -1) {
      config.headers['companyId'] = '-';
    } else {
      if (window.location.href.indexOf('toggleParklot') !== -1) {
        config.headers['companyId'] = '-';
      }
    }
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.interceptors.response.use(function (response) {
  if (response.data.errorCode === '0') {
    return response.data.result;
  }
  return response.data;
}, function (err) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].$vux.toast.show({ text: '网络异常', type: 'text' });
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
});

String.prototype.trim = function () {
  return this.replace(/(^\s*)|(\s*$)/g, '');
};

function loading(booleran) {
  if (booleran) {
    var container = document.createElement("div");
    container.id = "loading";
    container.style.position = 'fixed';
    container.style.zIndex = 100;
    container.style.width = '100%';
    container.style.height = '100%';
    container.style.top = 0;
    container.style.left = 0;
    container.style.display = 'flex';
    container.style.justifyContent = 'center';
    container.style.alignItems = 'center';
    var content = document.createElement("div");
    content.style.width = "70px";
    content.style.height = "70px";
    content.style.borderRadius = "10px";
    content.style.backgroundImage = "url('" + __webpack_require__("F7NO") + "')";
    content.style.backgroundSize = "100% 100%";
    content.style.backgroundPosition = "center center";
    content.style.backgroundRepeat = "no-repeat";
    container.append(content);
    $("body").append(container);
  } else {
    $("#loading").remove();
  }
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$config = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */]);
  },
  created: function created() {
    this.adjustScreen();

    if (this.$router.history.pending.name !== "download") {
      this.getCode();
    }
  },

  methods: {
    openAuthority: function openAuthority() {
      var href = window.location.href;
      var urlParams = href.split("#/")[1];
      var url = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].Url + urlParams;
      var redirectUri = encodeURIComponent(url);
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_base#wechat_redirect';
    },
    getCode: function getCode() {
      var _this = this;

      var code = __WEBPACK_IMPORTED_MODULE_11__tools_tool__["a" /* default */].getUrlParam('code');
      if (!code) {
        this.openAuthority();
      } else {
        loading(true);
        __WEBPACK_IMPORTED_MODULE_9__api_pay__["a" /* default */].authorization({ appid: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].appid, code: code }).then(function (res) {
          loading(false);
          var data = res.data;
          var openId = data.openId;
          _this.$store.commit('payParams/getPayParams', data);
          _this.$store.commit('payParams/getOpenId', openId);
          _this.$wechat.config({
            beta: true,
            debug: false,
            appId: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr, // 随机串
            signature: data.signature,
            jsApiList: ['chooseInvoiceTitle', 'addCard', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard', 'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline', 'hideOptionMenu', 'hideMenuItems']
          });
          _this.$wechat.ready(function (res) {
            console.log("页面加载完成");
          });
          _this.$wechat.error(function (res) {
            console.log("jsapi异常错误:", res);
            console.log("config参数", {
              beta: true,
              debug: false,
              appId: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].appid,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr, // 随机串
              signature: data.signature,
              jsApiList: ['chooseInvoiceTitle', 'addCard', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard', 'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline', 'hideOptionMenu', 'hideMenuItems']
            });
          });
        }).catch(function (err) {
          loading(false);
          setTimeout(function () {
            _this.openAuthority();
          }, 5000);
        });
      }
    },
    adjustScreen: function adjustScreen() {
      if ((typeof WeixinJSBridge === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(WeixinJSBridge)) == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if (document.attachEvent) {

          document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
      }
      function handleFontSize() {

        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });

        WeixinJSBridge.on('menu:setfont', function () {
          WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        });
      }
    }
  }
}).$mount('#app-box');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("4kSj")))

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 安装 Vue.js 插件。如果插件是一个对象，必须提供 install 方法。
// 如果插件是一个函数，它会被作为 install 方法。install 方法将被作为 Vue 的参数调用。
function install(Vue) {
  var filtersContext = __webpack_require__("GRGv");
  filtersContext.keys().map(function (key) {
    var filter = filtersContext(key).default;
    for (var prop in filter) {
      Vue.filter(prop, filter[prop]);
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = (install);

/***/ }),

/***/ "Q7uw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tw8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__ = __webpack_require__("yD8N");


/* harmony default export */ __webpack_exports__["a"] = ({

  getDicts: function getDicts(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vux_src_plugins_ajax_index_js__["a" /* default */].$http.get('/api/admin/sysDict/queryByDictType/' + data);
  }
});

/***/ }),

/***/ "UELi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.goBack = function () {
    this.isBack = true;
    window.history.go(-1);
};
var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
    return originalPush.call(this, location).catch(function (err) {
        return err;
    });
};

__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.common = {
    scrollPos: []
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.meta.keepAlive) {
            var scrollTop = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.common.scrollPos[to.name] || 0;
            if (scrollTop) {
                setTimeout(function () {
                    var documentElem = document.querySelector('.scrollYContainer');
                    if (documentElem) {
                        documentElem.scrollTop = scrollTop;
                    }
                }, 0);
            }
        }
    },

    routes: [{
        path: '/',
        name: 'index',
        redirect: '/mainIndex',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L8Y5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '首页'
        }
    }, {
        path: '/front',
        name: 'front',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2/Zj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '首页'
        }
    }, {
        path: '/personalInfo',
        name: 'personalInfo',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mdBc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '个人中心'
        }
    }, {
        path: '/success',
        name: 'success',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wyWd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '成功'
        }
    }, {
        path: '/addWxCoupon',
        name: 'addWxCoupon',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("znCd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '领取优惠券'
        }
    }, {
        path: '/couponsAuditList',
        name: 'couponsAuditList',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xE8e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '审批列表'
        }
    }, {
        path: '/auditConfirm',
        name: 'auditConfirm',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7uhN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '审批确认'
        }
    }, {
        path: '/chargeMoney',
        name: 'chargeMoney',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(63)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XVvU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '付款'
        }
    }, {
        path: '/invoiceHome',
        name: 'invoiceHome',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vUg9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '开票中心'
        }
    }, {
        path: '/invoiceImg',
        name: 'invoiceImg',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("q3P1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '电子发票预览'
        }
    }, {
        path: '/testImg',
        name: 'testImg',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(74)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P5p5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '图片放大'
        }
    }, {
        path: '/couponsInvoice',
        name: 'couponsInvoice',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(69)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9wG3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '优惠券发票'
        }
    }, {
        path: '/monthInvoice',
        name: 'monthInvoice',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(60)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zwD+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡发票'
        }
    }, {
        path: '/invoiceSuccess',
        name: 'invoiceSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zsNH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '发票申请成功'
        }
    }, {
        path: '/myInvoice',
        name: 'myInvoice',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9ST7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '开票历史'
        }
    }, {
        path: '/invoiceDetail2',
        name: 'invoiceDetail2',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M01V")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '发票详情'
        }
    }, {
        path: '/invoiceParkingRecord',
        name: 'invoiceParkingRecord',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(66)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+FVu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '缴费记录'
        }
    }, {
        path: '/secondApplyInvoiceSuccess',
        name: 'secondApplyInvoiceSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HzPA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '重开发票'
        }
    }, {
        path: '/againApplyInvoice',
        name: 'againApplyInvoice',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HwxG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '重开发票'
        }
    }, {
        path: '/personalInfoPingYun',
        name: 'personalInfoPingYun',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Xz/T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '停车缴费'
        }
    }, {
        path: '/personMerchant',
        name: 'personMerchant',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MC7k")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户管理'
        }
    }, {
        path: '/payWarn',
        name: 'payWarn',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5V6f")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '支付提示'
        }
    }, {
        path: '/scanQrcPay',
        name: 'scanQrcPay',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ztUQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '扫码支付'
        }
    }, {
        path: '/historyCoupons',
        name: 'historyCoupons',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(59)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Sz8q")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '历史卡券'
        }
    }, {
        path: '/merchantsInfo',
        name: 'merchantsInfo',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(79)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("abLm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户信息'
        }
    }, {
        path: '/personMonth',
        name: 'personMonth',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tIBo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡办理'
        }
    }, {
        path: '/parkingGuidance',
        name: 'parkingGuidance',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ii9i")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '反向寻车'
        }
    }, {
        path: '/pay',
        name: 'pay',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fVNB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '停车缴费'
        }
    }, {
        path: '/payHotel',
        name: 'payHotel',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aiMN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '记账车绑定'
        }
    }, {
        path: '/couponsCarEenter',
        name: 'couponsCarEenter',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JVar")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '优惠车牌登记'
        }
    }, {
        path: '/monthlyChange',
        name: 'monthlyChange',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("siiD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '套餐更改'
        }
    }, {
        path: '/monthChangeDetailPay',
        name: 'monthChangeDetailPay',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(84)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("K79Z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '套餐更改'
        }
    }, {
        path: '/couponsInstructions',
        name: 'couponsInstructions',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PZmF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '优惠券使用说明'
        }
    }, {
        path: '/qrcPay',
        name: 'qrcPay',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d5qt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '停车缴费'
        }
    }, {
        path: '/unlicensedQroNew',
        name: 'unlicensedQroNew',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(73)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jZec")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '无牌车进场'
        }
    }, {
        path: '/visitorsAppointment',
        name: 'visitorsAppointment',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("H9Iu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '访客预约'
        }
    }, {
        path: '/secondPay',
        name: 'secondPay',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/qVa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '确认缴费'
        }
    }, {
        path: '/monthApplication',
        name: 'monthApplication',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TM4T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡申请'
        }
    }, {
        path: '/monthApplicationPay',
        name: 'monthApplicationPay',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(67)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("W8+R")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡缴费'
        }
    }, {
        path: '/monthApplicationDetailPay',
        name: 'monthApplicationDetailPay',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ceig")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡续费'
        }
    }, {
        path: '/billDetail',
        name: 'billDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Fe/E")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡缴费详情'
        }
    }, {
        path: '/chargingStandard',
        name: 'chargingStandard',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OaiO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '收费标准'
        }
    }, {
        path: '/monthlyGuarantee',
        name: 'monthlyGuarantee',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SuCm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '月卡查缴'
        }
    }, {
        path: '/coupons',
        name: 'coupons',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RWhk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '领取优惠券'
        }
    }, {
        path: '/unlicensedQro',
        name: 'unlicensedQro',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sru8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '无牌车出场'
        }
    }, {
        path: '/myCoupons',
        name: 'myCoupons',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(77)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Dktr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '优惠券'
        }
    }, {
        path: '/merchantsCoupons',
        name: 'merchantsCoupons',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MCQz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户卡券'
        }
    }, {
        path: '/applyCoupon',
        name: 'applyCoupon',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("F+m8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '申请代金券'
        }
    }, {
        path: '/couponsDetail',
        name: 'couponsDetail',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jXs+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '优惠券详情'
        }
    }, {
        path: '/packageDetails',
        name: 'packageDetails',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ILCz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '套餐详情'
        }
    }, {
        path: '/parkingRecord',
        name: 'parkingRecord',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Tmid")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '停车记录'
        }
    }, {
        path: '/payList',
        name: 'payList',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(61)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("D4VL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '缴费流水'
        }
    }, {
        path: '/merchantsRegister',
        name: 'merchantsRegister',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("78Es")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户登记'
        }
    }, {
        path: '/payDetail',
        name: 'payDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mDav")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '缴费详情'
        }
    }, {
        path: '/applyProgress',
        name: 'applyProgress',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NyT1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '申请进度'
        }
    }, {
        path: '/accompanyCarMan',
        name: 'accompanyCarMan',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UriD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '随车人员'
        }
    }, {
        path: '/toggleParklot',
        name: 'toggleParklot',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/KnB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '切换车场'
        }
    }, {
        path: '/historyRecord',
        name: 'historyRecord',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Q66Y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '历史审核记录'
        }
    }, {
        path: '/historyRecordDetail',
        name: 'historyRecordDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("g6gZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '审核记录详情'
        }
    }, {
        path: '/myCar',
        name: 'myCar',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("X1UV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '我的车辆'
        }
    }, {
        path: '/bindVehicle',
        name: 'bindVehicle',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(82)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("J9y1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '车辆绑定'
        }
    }, {
        path: '/merchants',
        name: 'merchants',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(64)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M5bj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户绑定授权'
        }
    }, {
        path: '/publicDiscount',
        name: 'publicDiscount',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(58)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T0uQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户优惠'
        }
    }, {
        path: '/publicDiscountNb',
        name: 'publicDiscountNb',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(75)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M2SU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '内部优惠'
        }
    }, {
        path: '/publicDiscountList',
        name: 'publicDiscountList',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RtFF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '优惠发放记录'
        }
    }, {
        path: '/renewalAudit',
        name: 'renewalAudit',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(83)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WwEJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '续费审核'
        }
    }, {
        path: '/test',
        name: 'test',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KnCV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: 'test'
        }
    }, {
        path: '/upload',
        name: 'upload',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("17Qt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: 'upload'
        }
    }, {
        path: '/uploader',
        name: 'uploader',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mocU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: 'uploader'
        }
    }, {
        path: '/couponsLogin',
        name: 'couponsLogin',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eHAj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户登录'
        }
    }, {
        path: '/mainIndex',
        name: 'mainIndex',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6dcF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '主页'
        }
    }, {
        path: '/merchantIndex',
        name: 'merchantIndex',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IhK5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '商户管理'
        }
    }, {
        path: '/myInvoice/index',
        name: 'myInvoice-index',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TYiV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '我的发票'
        }
    }, {
        path: '/myInvoice/detail',
        name: 'myInvoice-detail',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IIfS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '发票详情'
        }
    }, {
        path: '/myInvoice/record',
        name: 'myInvoice-record',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T1UQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '缴费记录'
        }
    }, {
        path: '/myInvoice/view',
        name: 'myInvoice-view',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rKer")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '电子发票预览'
        }
    }, {
        path: '/myHander/index',
        name: 'myHander-index',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3Vk7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '我的发票抬头'
        }
    }, {
        path: '/myHander/detail',
        name: 'myHander-detail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TmSK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '发票抬头管理'
        }
    }, {
        path: '/xyInvoice/electronicInvoice2',
        name: 'electronicInvoice',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dpAx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '停车发票'
        }
    }, {
        path: '/xyInvoice/issueInvoice',
        name: 'issueInvoice',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IAt0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '开具电子发票'
        }
    }, {
        path: '/xyInvoice/moreInfo',
        name: 'moreInfo',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yQbI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '更多内容'
        }
    }, {
        path: '/xyInvoice/applyInvoiceSuccess',
        name: 'applyInvoiceSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XPEs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '发票申请'
        }
    }, {
        path: '/xyInvoice/invoiceDetail',
        name: 'invoiceDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kkVT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '发票详情'
        }
    }, {
        path: '/download/index',
        name: 'download',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A7k9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
            title: '文件下载'
        }
    }]
}));

/***/ }),

/***/ "YkTy":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dict.js": "qitd",
	"./faceCompare.js": "JeNs",
	"./imgstore.js": "efWE",
	"./payParams.js": "wShz",
	"./user.js": "bREw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YkTy";

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  namespace: 'user', // 注意定义namespace, 将会在store中存储
  state: {
    openId: '123',
    id: '',
    menu: [],
    invoiceModel: true, //  发票入口和提示总开关
    invoiceTime: 0 //  发票可开天数限制，0无提示
  },
  getters: {
    openId: function openId(state) {
      return state.openId;
    },
    id: function id(state) {
      return state.id;
    }
  },
  actions: {
    updateUserInfo: function updateUserInfo(_ref, payload) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('updateUserInfo', payload);
    }
  },
  mutations: {
    updateUserInfo: function updateUserInfo(state, payload) {
      for (var prop in payload) {
        state[prop] = payload[prop];
      }
    },
    set_menu: function set_menu(state, payload) {
      state.menu = payload;
    },
    ser_invoiceTime: function ser_invoiceTime(state, time) {
      state.invoiceTime = time;
    }
  }
});

/***/ }),

/***/ "chh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dU/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//  ———————————————————————— 重复业务 ————————————————————————————
// 微信支付
function payLast(target) {
  target.$vux.loading.hide();
  var data = target.params;
  function onBridgeReady() {
    WeixinJSBridge.invoke('getBrandWCPayRequest', {
      appId: data.appId, // 公众号名称，由商户传入
      timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
      nonceStr: data.nonceStr, // 随机串
      'package': data.packageValue,
      signType: data.signType, // 微信签名方式：
      paySign: data.paySign // 微信签名
    }, function (res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        WeixinJSBridge.invoke('closeWindow', {}, function (res) {});
      }
    });
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
}

// 支付宝支付
function handleAlipay(paySign, target) {
  target.$vux.loading.hide();
  AlipayJSBridge.call('tradePay', {
    tradeNO: paySign, // 必传，此使用方式下该字段必传
    bizType: '', // 非必传，默认为 “trade”
    bizSubType: '', // 非必传，默认为 “”
    bizContext: '' // 非必传，默认为H5启动选项(safePayContext)
  }, function (result) {
    if (result.resultCode == '9000') {
      AlertModule.show({
        content: '<p style="text-align:center;padding-top:10px">\u4ED8\u6B3E\u6210\u529F\uFF0C\u8BF7\u79BB\u573A</p>',
        hideOnBlur: true,
        onHide: function onHide() {
          AlipayJSBridge.call('closeWebview');
        }
      });
    }
  });
}

// 成功提示
function successNotify(text) {
  Notification({
    title: '提示',
    type: 'success',
    message: text || '成功',
    duration: 1000
  });
}

// 对象深拷贝
function deepCopy(obj) {
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[key]) === 'object' && obj[key] !== null) {
        result[key] = deepCopy(obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  deepCopy: deepCopy,
  successNotify: successNotify,
  payLast: payLast,
  handleAlipay: handleAlipay
});

/***/ }),

/***/ "efWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_unlicensedCarOutIn__ = __webpack_require__("BmTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dict__ = __webpack_require__("Tw8E");


/* harmony default export */ __webpack_exports__["default"] = ({
  namespace: 'imgstore', // 注意定义namespace, 将会在store中存储
  state: {
    img_upload_cache: [],
    img_paths: [],
    img_status: 'ready' // 上传状态 ready selected uploading finished
  },
  getters: {
    img_upload_cache: function img_upload_cache(state) {
      return state.img_upload_cache;
    },
    img_paths: function img_paths(state) {
      return state.img_paths;
    },
    img_status: function img_status(state) {
      return state.img_status;
    }
  },
  actions: {},
  mutations: {
    set_img_upload_cache: function set_img_upload_cache(state, arg) {
      state.img_upload_cache = arg;
    },
    set_img_paths: function set_img_paths(state, arg) {
      state.img_paths = arg;
    },
    set_img_status: function set_img_status(state, arg) {
      state.img_status = arg;
    }
  }
});

/***/ }),

/***/ "g+Cn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  appid: "wx4753e8cdf3749bbf",
  Url: "https://carpark.grguser.com/#/",
  img: '/static/logoImg/pingyun.png',
  car: "A",
  payChannel: 1
});

/***/ }),

/***/ "gsj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kNDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a8526d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_grid_grid = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function injectStyle (ssrContext) {
  __webpack_require__("JvV8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  grid_grid,
  components_grid_grid,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kcuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_pay__ = __webpack_require__("HiEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");



var tool = {
  trim: function trim(str) {
    return str.replace(/\s+/g, '');
  },
  getUrlParam: function getUrlParam(name) {
    // 封装方法
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); // 匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; // 返回参数值
  },

  // 校验特殊字符
  validateName: function validateName(newName) {
    var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

    if (regEn.test(newName) || regCn.test(newName)) {
      return false;
    }
  },
  ValidatePhone: function ValidatePhone(val) {
    var isPhone = /^1(3|4|5|7|8|9)\d{9}$/; // 手机号码
    var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/; // 座机格式
    if (isMob.test(val) || isPhone.test(val)) {
      return true;
    } else {
      return false;
    }
  },

  // 校验身份证
  ValidateCardId: function ValidateCardId(val) {
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(val) === false) {
      return false;
    } else {
      return true;
    }
  },
  getBLen: function getBLen(str) {
    if (str == null) return 0;
    if (typeof str != 'string') {
      str += '';
    }
    return str.replace(/[^\x00-\xff]/g, '01').length;
  },
  getStrLen: function getStrLen(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      // 单字节加1
      if (c >= 0x0001 && c <= 0x007e || 0xff60 <= c && c <= 0xff9f) {
        len++;
      } else {
        len += 2;
      }
    }
    return len;
  },
  dictCheck: function dictCheck(arr, value) {
    var name = '';
    arr.forEach(function (item, index) {
      if (item.key == value) {
        name = item.value;
      }
    });
    return name;
  },

  // 车牌号验证方法
  isVehicleNumber: function isVehicleNumber(vehicleNumber) {
    var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
    var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
    if (vehicleNumber.length == 7) {
      return creg.test(vehicleNumber);
    } else if (vehicleNumber.length == 8) {
      return xreg.test(vehicleNumber);
    } else {
      return false;
    }
  },

  // 校验车牌号码
  carNumber: function carNumber(rule, value, callback) {
    var param = value.trim();
    var isletter = /^[a-zA-Z]+$/.test(param);
    var isNum = /^[0-9]+$/.test(param);
    var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
    var regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
    if (!isletter && !isNum) {
      if (regEn.test(param) || regCn.test(param)) {
        callback(new Error('请输入正确的车牌号码'));
      } else {
        if (param.length != 7 && param.length != 8) {
          callback(new Error('请输入正确的车牌号码'));
        } else {
          callback();
        }
      }
    } else {
      callback(new Error('请输入正确的车牌号码'));
    }
  },
  isEmailAddress: function isEmailAddress(obj) {
    var pattern = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
    var flag = pattern.test(obj);
    return flag;
  },

  // 校验手机号码
  checkPhone: function checkPhone(str) {
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(str)) {
      return false;
    } else {
      return true;
    }
  },
  isTel: function isTel(str) {
    var reg = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/;
    if (!reg.test(str)) {
      return false;
    } else {
      return true;
    }
  },

  // 2.利用sort排序
  sortArr: function sortArr(arr) {
    return arr.sort(function (a, b) {
      return a.endTimestamp - b.endTimestamp; // 升序
      // return b - a; // 降序
    });
  },

  // 传入一个数组
  // 按照特定方式格式化,JavaScript 将数组中具有相同值的对象 取出组成新的数组
  sortSameNameArr: function sortSameNameArr(arr, str) {
    var _arr = [],
        _t = [],

    // 临时的变量
    _tmp = void 0;
    var _arr2 = {};
    for (var i in arr) {
      if (_arr2[arr[i].cardId]) {
        _arr2[arr[i].cardId].push(arr[i]);
      } else {
        _arr2[arr[i].cardId] = [arr[i]];
      }
    }
    // 按照特定的参数将数组排序将具有相同值得排在一起
    arr = arr.sort(function (a, b) {
      var s = a[str],
          t = b[str];
      return s < t ? -1 : 1;
    });
    if (arr.length) {
      _tmp = arr[0][str];
    }
    // console.log( arr );
    // 将相同类别的对象添加到统一个数组
    for (var _i in arr) {
      if (arr[_i][str] === _tmp) {
        _t.push(arr[_i]);
      } else {
        _tmp = arr[_i][str];
        _arr.push(_t);
        _t = [arr[_i]];
      }
    }
    // 将最后的内容推出新数组
    _arr.push(_t);
    return _arr;
  },

  // 校验金额
  money: function money(value) {
    var money = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
    if (!money.test(value)) {
      return false;
    } else {
      return true;
    }
  },

  // 校验openId
  getWeixinCode: function getWeixinCode(appType, callback) {
    var _this = this;

    var code = void 0;
    if (appType == 'wx') {
      code = tool.getUrlParam('code');
    } else {
      code = tool.getUrlParam('auth_code');
    }
    if (!code) {
      var href = window.location.href;
      var urlParams = href.split('#/')[1];
      var url = this.$config.Url + urlParams; // 平云广场测试
      var redirectUri = encodeURIComponent(url);
      if (appType == 'wx') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.$config.appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo#wechat_redirect';
      } else {
        window.location.href = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=' + this.$config.appid + '&scope=auth_base' + '&redirect_uri=' + redirectUri;
      }
    } else {
      var param = {
        appid: this.$config.appid,
        code: code
        // alert(auth_code)
        // alert(JSON.stringify(param))
      };if (appType == 'wx') {
        __WEBPACK_IMPORTED_MODULE_1__api_pay__["a" /* default */].authorization(param).then(function (res) {
          var data = res.data;
          var openId = data.openId;
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('payParams/getOpenId', openId);
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('payParams/getPayParams', data);
          _this.$wechat.config({
            debug: false,
            appId: appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr, // 随机串
            signature: data.signature,
            jsApiList: ['checkJsApi', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard', 'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline', 'addCard', 'hideOptionMenu', 'hideMenuItems']
          });
          callback();
        }).catch(function (err) {
          console.log('err', err);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__api_pay__["a" /* default */].aliUserInfo(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param)).then(function (res) {
          // alert(res.data.openId)
          // console.log("支付宝请求数据res",res)
          var data = res.data;
          var openId = data.openId;
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('payParams/getOpenId', openId);
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('payParams/getPayParams', data);
          callback();
        }).catch(function (err) {
          // alert(JSON.stringify(err))
          console.log('err', err);
        });
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (tool);

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("TuEr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pDNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_input = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("+LB2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_input,
  src_components_x_input,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pLXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToggleBtn.vue
//
//
//
//
//
//

/* harmony default export */ var ToggleBtn = ({
  data: function data() {
    return {
      flags: false,
      position: {
        x: 0,
        y: 0
      },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      styleLeft: '',
      styleTop: '',
      moveBtn: {}
    };
  },
  mounted: function mounted() {
    this.moveBtn = this.$refs.moveBtn;
  },

  methods: {
    toPage: function toPage() {
      this.$store.commit('payParams/isClickParklot', true);
      this.$router.push('toggleParklot');
    },

    // 实现移动端拖拽
    down: function down() {
      this.flags = true;
      var touch = void 0;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.moveBtn.offsetLeft;
      this.dy = this.moveBtn.offsetTop;
    },
    move: function move() {
      if (this.flags) {
        var touch = void 0;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.styleLeft = this.dx + this.nx;
        this.styleTop = this.dy + this.ny;
        var clientWidth = document.documentElement.clientWidth;
        var clientHeight = document.documentElement.clientHeight;
        if (this.styleLeft > 0 && this.styleLeft < clientWidth - this.moveBtn.offsetWidth) {
          this.moveBtn.style.left = this.styleLeft + 'px';
        }
        if (this.styleTop > 0 && this.styleTop < clientHeight - this.moveBtn.offsetHeight) {
          this.moveBtn.style.top = this.styleTop + 'px';
        }
        // 阻止页面的滑动默认事件
        document.addEventListener('touchmove', this.handler, {
          passive: false
        });
      }
    },

    // 鼠标释放时候的函数
    end: function end() {
      this.flags = false;
      document.addEventListener('touchmove', this.handler, {
        passive: false
      });
    },
    handler: function handler() {
      if (this.flags) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToggleBtn.vue
//
//
//
//
//
//

/* harmony default export */ var components_ToggleBtn = ({
  data: function data() {
    return {
      flags: false,
      position: {
        x: 0,
        y: 0
      },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      styleLeft: '',
      styleTop: '',
      moveBtn: {}
    };
  },
  mounted: function mounted() {
    this.moveBtn = this.$refs.moveBtn;
  },

  methods: {
    toPage: function toPage() {
      this.$store.commit('payParams/isClickParklot', true);
      this.$router.push('toggleParklot');
    },

    // 实现移动端拖拽
    down: function down() {
      this.flags = true;
      var touch = void 0;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.moveBtn.offsetLeft;
      this.dy = this.moveBtn.offsetTop;
    },
    move: function move() {
      if (this.flags) {
        var touch = void 0;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.styleLeft = this.dx + this.nx;
        this.styleTop = this.dy + this.ny;
        var clientWidth = document.documentElement.clientWidth;
        var clientHeight = document.documentElement.clientHeight;
        if (this.styleLeft > 0 && this.styleLeft < clientWidth - this.moveBtn.offsetWidth) {
          this.moveBtn.style.left = this.styleLeft + 'px';
        }
        if (this.styleTop > 0 && this.styleTop < clientHeight - this.moveBtn.offsetHeight) {
          this.moveBtn.style.top = this.styleTop + 'px';
        }
        // 阻止页面的滑动默认事件
        document.addEventListener('touchmove', this.handler, {
          passive: false
        });
      }
    },

    // 鼠标释放时候的函数
    end: function end() {
      this.flags = false;
      document.addEventListener('touchmove', this.handler, {
        passive: false
      });
    },
    handler: function handler() {
      if (this.flags) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e07619","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleBtn.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"moveBtn",staticClass:"toggle-park-style",on:{"click":function($event){return _vm.toPage()},"mousedown":_vm.down,"touchstart":_vm.down,"mousemove":_vm.move,"touchmove":_vm.move,"mouseup":_vm.end,"touchend":_vm.end,"touchcancel":_vm.end}},[_vm._v("\n    切换车场\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ToggleBtn = (esExports);
// CONCATENATED MODULE: ./src/components/ToggleBtn.vue
function injectStyle (ssrContext) {
  __webpack_require__("chh4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19e07619"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_ToggleBtn,
  selectortype_template_index_0_src_components_ToggleBtn,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_ToggleBtn = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qitd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_unlicensedCarOutIn__ = __webpack_require__("BmTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dict__ = __webpack_require__("Tw8E");



/* harmony default export */ __webpack_exports__["default"] = ({
  namespace: 'dict', // 注意定义namespace, 将会在store中存储
  state: {
    colorList: [{ key: 0, value: '未知' }, { key: 1, value: '蓝色' }, { key: 2, value: '黄色' }, { key: 3, value: '白色' }, { key: 4, value: '黑色' }, { key: 5, value: '绿色' }],
    parklotList: [],
    channelList: [],
    plateTypeList: [],
    parklotIdDict: '',
    statusList: [{ key: 1, value: '初始化' }, { key: 2, value: '未生效' }, { key: 3, value: '生效中' }, { key: 4, value: '已过期' }],
    couponsList: [],
    couponsIndex: [],
    listParklotsData: [],
    judgeList: [{ key: 1, value: '是' }, { key: 2, value: '否' }]
  },
  getters: {
    colorList: function colorList(state) {
      return state.colorList;
    },
    parklotList: function parklotList(state) {
      return state.parklotList;
    },
    channelList: function channelList(state) {
      return state.channelList;
    },
    plateTypeList: function plateTypeList(state) {
      return state.plateTypeList;
    },
    statusList: function statusList(state) {
      return state.statusList;
    },
    couponsList: function couponsList(state) {
      return state.couponsList;
    },
    couponsIndex: function couponsIndex(state) {
      return state.couponsIndex;
    },
    listParklotsData: function listParklotsData(state) {
      return state.listParklotsData;
    },
    judgeList: function judgeList(state) {
      return state.judgeList;
    }
  },
  actions: {
    // 获取用户全部停过的停车场
    getListParklotsAction: function getListParklotsAction(_ref, account) {
      var commit = _ref.commit,
          state = _ref.state;

      var obj = {
        account: account
      };
      commit('getlistParklotsDataMutations', []);
      __WEBPACK_IMPORTED_MODULE_1__api_unlicensedCarOutIn__["a" /* default */].listParklots(obj).then(function (res) {
        if (res.status === 200) {
          var data = res.data;
          var arr = [];
          data.forEach(function (item, index) {
            var obj = {
              key: item.payParkId,
              value: item.payParkName
            };
            arr.push(obj);
          });
          commit('getlistParklotsDataMutations', arr);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    // 获取停车场
    getParklotListActions: function getParklotListActions(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      commit('getParklotListMutations', []);
      __WEBPACK_IMPORTED_MODULE_1__api_unlicensedCarOutIn__["a" /* default */].parklotList().then(function (res) {
        if (res.status === 200) {
          var data = res.result;
          var arr = [];
          data.forEach(function (item, index) {
            var obj = {
              key: item.id,
              value: item.name
            };
            arr.push(obj);
          });
          commit('getParklotListMutations', arr);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    // 获取通道
    getChannelListActions: function getChannelListActions(_ref3, id) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var data = {
        'parklotId': id.parklotId,
        'outinType': id.outinType
      };
      commit('getChannelListMutations', []);
      __WEBPACK_IMPORTED_MODULE_1__api_unlicensedCarOutIn__["a" /* default */].channelList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (res) {
        if (res.status === 200) {
          var _data = res.data;
          var arr = [];
          _data.forEach(function (item, index) {
            var obj = {
              key: item.id,
              value: item.name
            };
            arr.push(obj);
          });
          commit('getChannelListMutations', arr);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    // 获取车辆类型
    getPlateTypeListActions: function getPlateTypeListActions(_ref4, id) {
      var commit = _ref4.commit,
          state = _ref4.state;

      var data = 'PLATE_TYPE';
      commit('getPlateTypeListMutations', []);
      __WEBPACK_IMPORTED_MODULE_2__api_dict__["a" /* default */].getDicts(data).then(function (res) {
        if (res) {
          var _data2 = res;
          var arr = [];
          _data2.forEach(function (item, index) {
            var obj = {
              'key': parseInt(item.dictValue),
              'value': item.dictName
            };
            arr.push(obj);
          });
          commit('getPlateTypeListMutations', arr);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mutations: {
    getPayParams: function getPayParams(state, value) {
      state.payParams = value;
    },
    getOpenId: function getOpenId(state, value) {
      state.openId = value;
    },
    getParklotListMutations: function getParklotListMutations(state, value) {
      state.parklotList = value;
    },
    getChannelListMutations: function getChannelListMutations(state, value) {
      state.channelList = value;
    },
    getPlateTypeListMutations: function getPlateTypeListMutations(state, value) {
      state.plateTypeList = value;
    },
    getCouponsListMutations: function getCouponsListMutations(state, value) {
      state.couponsList = value;
    },
    getCouponsIndexMutations: function getCouponsIndexMutations(state, value) {
      state.couponsIndex = value;
    },
    getlistParklotsDataMutations: function getlistParklotsDataMutations(state, value) {
      state.listParklotsData = value;
    }
  }
});

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uWE6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uWE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wShz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_tool__ = __webpack_require__("kcuN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_pay__ = __webpack_require__("HiEW");



/* harmony default export */ __webpack_exports__["default"] = ({
  namespace: 'payParams', // 注意定义namespace, 将会在store中存储
  state: {
    payParams: {},
    openId: '',
    // openId: '031XQnGa1agoPA0GQBFa1fTFmq3XQnGQ', // 袁杏全
    id: '',
    data: {},
    payMoney: {},
    plateNumId: '',
    payDetail: {},
    conpousSelect: [],
    conpousList: [],
    plateCarNumber: '',
    plateCarData: {},
    cashMon: '',
    temMonData: [],
    appType: 'wx',
    noPlateParams: {},
    totalAccountMoney: 0,
    applyInvoice: {},
    readySelectArr: [],
    invoiceDetailData: {},
    invoicSecondApplyData: {},
    invoiceOrderId: '',
    invoiceMoreInfo: {},
    scrollBottom: undefined, // 列表滚动的距离
    payParkId: '',
    isClickParklot: false,
    Party_C_Object: {},
    goBackStatus: false,
    parklotInfo: JSON.parse(localStorage.getItem('parklotInfo')),
    parklotInfoIsSend: false,
    goBackEvent: function goBackEvent() {}
  },
  getters: {
    payParams: function payParams(state) {
      return state.payParams;
    },
    openId: function openId(state) {
      return state.openId;
    },
    id: function id(state) {
      return state.id;
    },
    data: function data(state) {
      return state.data;
    },
    payMoney: function payMoney(state) {
      return state.payMoney;
    },
    plateNumId: function plateNumId(state) {
      return state.plateNumId;
    },
    payDetail: function payDetail(state) {
      return state.payDetail;
    },
    conpousSelect: function conpousSelect(state) {
      return state.conpousSelect;
    },
    conpousList: function conpousList(state) {
      return state.conpousList;
    },
    plateCarNumber: function plateCarNumber(state) {
      return state.plateCarNumber;
    },
    plateCarData: function plateCarData(state) {
      return state.plateCarData;
    },
    cashMon: function cashMon(state) {
      return state.cashMon;
    },
    temMonData: function temMonData(state) {
      return state.temMonData;
    },
    appType: function appType(state) {
      return state.appType;
    },
    noPlateParams: function noPlateParams(state) {
      return state.noPlateParams;
    },
    totalAccountMoney: function totalAccountMoney(state) {
      return state.totalAccountMoney;
    },
    applyInvoice: function applyInvoice(state) {
      return state.applyInvoice;
    },
    readySelectArr: function readySelectArr(state) {
      return state.readySelectArr;
    },
    invoiceDetailData: function invoiceDetailData(state) {
      return state.invoiceDetailData;
    },
    invoicSecondApplyData: function invoicSecondApplyData(state) {
      return state.invoicSecondApplyData;
    },
    invoiceOrderId: function invoiceOrderId(state) {
      return state.invoiceOrderId;
    },
    invoiceMoreInfo: function invoiceMoreInfo(state) {
      return state.invoiceMoreInfo;
    },
    payParkId: function payParkId(state) {
      return state.payParkId;
    },
    scrollBottom: function scrollBottom(state) {
      return state.scrollBottom;
    },
    isClickParklot: function isClickParklot(state) {
      return state.isClickParklot;
    },
    Party_C_Object: function Party_C_Object(state) {
      return state.Party_C_Object;
    }, // 与卡缴费，是否存在第三方
    goBackStatus: function goBackStatus(state) {
      return state.goBackStatus;
    }
  },
  actions: {
    // actionsOpenId({commit,state},id){
    //     commit("getOpenId",'')
    //     commit("getPayParams",{})
    //     let href = window.location.href
    //     let urlParams = href.split("#/")[1]
    //     let url="https://tcct.grgyintong.com/#/"+urlParams
    //     let appid='wxf285ea85c975a59e'
    //     // let url="https://tcc.grgyintong.com/#/"+urlParams
    //     // let appid='wxfd559cd8f44405f1' //平云广场
    //     // let appid='wx1ce3ed8c30f71b9c' //旧的开发公众号
    //     let redirectUri = encodeURIComponent(url)
    //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
    //     Api.authorization(code).then(res => {
    //       let appid='wxf285ea85c975a59e'
    //       let data=res.data
    //       let openId=data.openId
    //       commit("getOpenId",openId)
    //       commit("getPayParams",data)
    //       this.$wechat.config({
    //         debug: false,
    //         appId:  data.appId,
    //         timestamp: data.timestamp,
    //         nonceStr:data.nonceStr, //随机串
    //         signature: data.signature,
    //         jsApiList: ['checkJsApi', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard',
    //           'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline','addCard','hideOptionMenu','hideMenuItems'
    //         ]
    //       })
    //       this.$wechat.ready(function () {
    //         // this.$wechat.hideOptionMenu()
    //       })
    //     }).catch(err => {
    //       console.log(`err`, err)
    //     })
    // }
  },
  mutations: {
    getPayParams: function getPayParams(state, value) {
      state.payParams = value;
    },
    getOpenId: function getOpenId(state, value) {
      state.openId = value;
    },
    getId: function getId(state, value) {
      state.id = value;
    },
    getData: function getData(state, value) {
      state.data = value;
    },
    getPayMoney: function getPayMoney(state, value) {
      state.payMoney = value;
    },
    getParklotInfoIsSend: function getParklotInfoIsSend(state, value) {
      state.parklotInfoIsSend = value;
    },
    getPlateNumId: function getPlateNumId(state, value) {
      state.plateNumId = value;
    },
    getPayDetail: function getPayDetail(state, value) {
      state.payDetail = value;
    },
    getConpousSelect: function getConpousSelect(state, value) {
      state.conpousSelect = value;
    },
    getConpousList: function getConpousList(state, value) {
      state.conpousList = value;
    },
    getPlateCarNumber: function getPlateCarNumber(state, value) {
      state.plateCarNumber = value;
    },
    getPlateCarData: function getPlateCarData(state, value) {
      state.plateCarData = value;
    },
    getCash: function getCash(state, value) {
      state.cashMon = value;
    },
    getTemMonData: function getTemMonData(state, value) {
      state.temMonData = value;
    },
    getAppType: function getAppType(state, value) {
      state.appType = value;
    },
    getParams: function getParams(state, value) {
      state.noPlateParams = value;
    },
    getParklotInfo: function getParklotInfo(state, value) {
      state.parklotInfo = value;
    },
    getTotalAccountMoney: function getTotalAccountMoney(state, value) {
      state.totalAccountMoney = value;
    },
    getGoBackStatus: function getGoBackStatus(state, value) {
      state.goBackStatus = value;
    },
    getGoBackEvent: function getGoBackEvent(state, value) {
      state.goBackEvent = function () {
        state.goBackStatus = true;
      };
    },
    getApplyInvoice: function getApplyInvoice(state, value) {
      state.applyInvoice = value;
    },
    getReadySelectArr: function getReadySelectArr(state, value) {
      state.readySelectArr = value;
    },
    getInvoiceDetailData: function getInvoiceDetailData(state, value) {
      state.invoiceDetailData = value;
    },
    getInvoicSecondApplyData: function getInvoicSecondApplyData(state, value) {
      state.invoicSecondApplyData = value;
    },
    getInvoiceOrderId: function getInvoiceOrderId(state, value) {
      state.invoiceOrderId = value;
    },
    getInvoiceMoreInfo: function getInvoiceMoreInfo(state, value) {
      state.invoiceMoreInfo = value;
    },
    getScrollBottom: function getScrollBottom(state, value) {
      state.scrollBottom = value;
    },
    getPayParkId: function getPayParkId(state, value) {
      state.payParkId = value;
    },
    isClickParklot: function isClickParklot(state, value) {
      state.isClickParklot = value;
    },
    getPartyC_Object: function getPartyC_Object(state, value) {
      state.Party_C_Object = value;
    }
  }
});

/***/ }),

/***/ "wwIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0012d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_selector = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("G6U3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_selector,
  src_components_selector,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wwVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  myFilter: function myFilter(val) {
    console.log(val);
    return 'defaultData';
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.17e2266da0211d28ee73.js